// extracted by mini-css-extract-plugin
module.exports = {"container":"_2DM-wJcq4jpA","header":"_3qNEKoYFB_Yu","date":"_2Zc9PVeXPNrQ","filter":"m7s66xU-aZep","flights":"Hlyj6VLr6328","errorMsg":"_2dKzHhjZC5Ih"};